/**
|--------------------------------------------------
| THIS COMPONENT HAS REBUILD ON 29-maret-2019
| Reason Rebuild: Implementing New Improved API 
|--------------------------------------------------
*/

import React from 'react';
import classnames from 'classnames'
import toUTCtime from '../../../../../helper/UTCtime';

// Component
import AllAssetRow from './AllAssetRow.js';
import FilterComponent from '../FilterComponent.js';
import ModalBooking from '../Modal/ModalBooking.js';
// import ModalDetailAsset from '../Modal/ModalDetailAsset.js';
import ModalDetailMyAsset from 'home/helper/component/Modal/ModalDetailMyAsset.js';
import Pagination from '../../../../../component/Pagination.js';

// TOAST
import { toast } from 'react-toastify';

//Icon
import iconMaping from '../../../../../utils/IconMaping.js';

import {RequestAsync} from 'config/RequestAsync.js'
import axios from 'axios';
import lang from 'config/language' 
import PopoverHelper from 'utils/PopoverHelper';

const URL = {
  "all" : "improved-read-asset",
  "idle" : "improved-read-asset-idle",
  "unavailable": "improved-read-asset-unavailable",
}

export default class AllAssetList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalDetail          : false,
      modalBooking         : false,

      SelectedItem         : null,
      DateBookingStart     : null,
      DateBookingStart_UTC : null,
      DateBookingEnd       : null,
      DateBookingEnd_UTC   : null,
      RowElement           : null,
      NewRowElement        : null,
      NextPage             : null,
      rawData              : [],
      SITE           : null,
      LOCATION       : null,
      activeToggle   : {
        activeIcon      : null,
        activeField     : 'Name',
      },
      isUpdateReservation : false,
      disabledBook        : true,
      isLoading           : true,
      // pagination
      table_loading : false,
      current       : 0,
      count         : 0,
      limit         : 0,
    }
    this._isMounted = false
    this.signal = axios.CancelToken.source()
    this.id_status_popover = 'all_asset_status';
    this.id_maintenance_popover = 'all_asset_maintenance';

    //* Default Param Filter & Order */
    this.params_filter = '';
    this.params_order = '-SortDate,-CreatedTime';
    this.params_page = 1;

    //* Auto generate filter combobox  */
    this.tab1 = ['asset', 'type', 'site', 'location', 'serial_number']
    this.tab2 = ['asset', 'type', 'site', 'location', 'serial_number']
    this.tab3 = ['asset', 'type', 'site', 'location', 'serial_number']

    this.loading = true;

    // Modal Detail
    this.toggleModalDetail  = this.toggleModalDetail.bind(this);
    this.closeModalDetail   = this.closeModalDetail.bind(this);

    // Modal Booking
    this.toggleModalBooking = this.toggleModalBooking.bind(this);
    this.closeModalBooking  = this.closeModalBooking.bind(this);

    this.updateReservation = this.updateReservation.bind(this)

  }

  updateReservation() {
    this.setState({
      isUpdateReservation: true,
      disabledBook: true,
    })
  }

  toggleModalDetail(e, data) {
    e.preventDefault();
    this.setState({
      SelectedItem  : data,
      modalDetail   : true,
    })
  }

  closeModalDetail(){
    this.setState({
      modalDetail: false,
    })
  }

  toggleModalBooking(date) {
    if(date != null) {
      date.start._d.setHours(9);
      date.start._d.setMinutes(0);
      date.start._d.setSeconds(0);

      date.end._d.setHours(8);
      date.end._d.setMinutes(59);
      date.end._d.setSeconds(59);

      this.setState({
        modalBooking         : !this.state.modalBooking,
        DateBookingStart     : date.start._d,
        DateBookingStart_UTC : toUTCtime(date.start._d),
        DateBookingEnd       : date.end._d,
        DateBookingEnd_UTC   : toUTCtime(date.end._d),
      })
    } else {
      toast.warning("select the date of booking")
    }
  }

  closeModalBooking(){
    this.setState({
      modalBooking     : false,
    })
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (<AllAssetRow self={this} rowData={val} history={this.props.history} key={index}></AllAssetRow>)
    })
    return element;
  }

  onLoad = async () => {
    const {Cluster} = this.props

    try {
      let data = Object.assign({
        page     : this.params_page,
        ordering : this.params_order,
      }, this.params_filter)

      this.loading = false
      const response = await RequestAsync(
        URL[Cluster], 
        {Authorization: "Bearer " + this.props.UserReducer.token},
        data,
        this.signal.token
      )
      
      if(this._isMounted) {
        this.setState({
          rawData       : response.data.results,
          isLoading     : false,
          table_loading : false,
          current       : response.data.current,
          count         : response.data.count,
          limit         : response.data.limit,
        })
      }

    } catch (err) {
      this.loading = false
      if(this._isMounted) {
        this.setState({
          table_loading : false,
        })
      }
    }
  }

  dataWillFilter(filter){
    this.params_filter = filter;
    this.params_page   = 1;
    this.onLoad()
  }

  /* ORDER DATA */
  dataWillOrder(order){
    let parameterOder = order;
    this.setState({activeToggle: {
      activeField : order,
      activeIcon  : iconMaping.AVICON_ASC
    }})

    if(this.params_order === parameterOder){
      this.params_order = '-' + order;
      this.setState({activeToggle: {
        activeField : order,
        activeIcon  : iconMaping.AVICON_DESC
      } })
    } else {
      this.params_order = parameterOder;
      this.setState({activeToggle: {
        activeField : order,
        activeIcon  : iconMaping.AVICON_ASC
      } })
    }

    this.onLoad()
  }

  // Pagination
  handlePageClick = (data) => {
    let selected = data.selected + 1;
    this.params_page = selected

    this.setState({ table_loading: true})
    this.onLoad()
  }

  RenderRowElement() {
    if(this.state.isLoading) {
      return (<tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>)
    }
    else if(this.state.count === 0) {
      return (<tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>)
    }
    else if (this.state.count > 0){
      return (this.generateRow(this.state.rawData))
    }
    else {
      return (<tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>)
    }
  }

  RenderTitle(cluster) {
    if(cluster === 'all') {
      this.id_status_popover = 'all_asset_status';
      this.id_maintenance_popover = 'all_asset_maintenance';
      return(
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_DIAMOND}></span>&nbsp;All Assets/ Tools</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.count}</span>&nbsp;Asset
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent 
              onSearch={(e) => {this.dataWillFilter(e)}} 
              self={this} 
              target={'all'} 
              FBColumn={this.tab1} 
              version={2}
            />
          </div>
        </div>
      )
    } else if(cluster === 'idle') {
      this.id_status_popover = 'idle_asset_status';
      this.id_maintenance_popover = 'idle_asset_maintenance';
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_DIAMOND}></span> Idle / Available Immediately</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.count}</span>&nbsp;Asset
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent 
              onSearch={(e) => {this.dataWillFilter(e)}} s
              self={this} 
              target={'idle'} 
              FBColumn={this.tab2} 
              version={2}
            />
          </div>
        </div>
      )
    } else {
      this.id_status_popover = 'unavailable_asset_status';
      this.id_maintenance_popover = 'unavailable_asset_maintenance';
      return (
        <div className="row">
          <div className="col-sm-5 book-a-tool-title">
            <h4 className="card-title mb-0">
              <span><span className={iconMaping.AVICON_DIAMOND}></span>&nbsp;Under Maintenance/ Need Repair</span>
            </h4>
            <div className="text-muted m-top-8">
              <div className="pull-left spaceRRR cursor-default">
                <span>Total:&nbsp;{this.state.count}</span>&nbsp;Asset
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <FilterComponent 
              onSearch={(e) => {this.dataWillFilter(e)}} 
              self={this} 
              target={'unavailable'} 
              FBColumn={this.tab3}
              version={2}
            />
          </div>
        </div>
      )
    }
  }

  mounted() {
    if(this._isMounted) {
      this.onLoad()
    }
  }

  componentDidMount() {
    this._isMounted = true
    this.mounted()
  }

  componentWillUnmount(){
    this._isMounted = false
    this.signal.cancel();
  }

  render() {
    const {
      current,
      count,
      limit,
      table_loading,
    } = this.state

    return (
      <div>
        {this.RenderTitle(this.props.Cluster)}
        <table className={classnames("table table-responsive table-hover table-outline mb-0 m-top-15 over-x", {"loading" : table_loading})}>
          <thead className="thead-default">
            <tr>
              <th onClick={()=>this.dataWillOrder('name')} className="pointer">
                Asset/Tool{this.state.activeToggle.activeField === 'name' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
              </th>
              <th onClick={()=>this.dataWillOrder('type')} className="pointer">
                Type{this.state.activeToggle.activeField === 'type' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
              </th>
              <th onClick={()=>this.dataWillOrder('serial_number')} className="pointer">
                Serial Number{this.state.activeToggle.activeField === 'serial_number' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
              </th>
              <th onClick={()=>this.dataWillOrder('owner')} className="text-center pointer">
                Assigned{this.state.activeToggle.activeField === 'owner' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
              </th>
              <th onClick={()=>this.dataWillOrder('site')} className="pointer">
                Site{this.state.activeToggle.activeField === 'site' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
              </th>
              <th onClick={()=>this.dataWillOrder('location')} className="pointer">
                Location{this.state.activeToggle.activeField === 'location' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
              </th>
              <th className="pointer">
                <span onClick={()=>this.dataWillOrder('status')}>Status</span><PopoverHelper
                    id={this.id_status_popover} 
                    content={lang.all_asset.status}
                  />{this.state.activeToggle.activeField === 'status' ? <i className={this.state.activeToggle.activeIcon}></i> : ' '}
              </th>
              <th className="text-center">Booking</th>
              <th className="text-center">Maintenance<PopoverHelper
                    id={this.id_maintenance_popover}
                    placement="left"
                    content={lang.all_asset.maintenance}
                  /></th>
            </tr>
          </thead>
          <tbody>
            {this.RenderRowElement()}
          </tbody>
        </table>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current  = {current}
              count    = {count}
              limit    = {limit}
              handle   = {this.handlePageClick}
              isLoading= {this.state.table_loading}
            />
          </div>
        </div>

        <ModalBooking
          siteMaster={this.state.SITE}
          locationMaster={this.state.LOCATION}
          selectedItem={this.state.SelectedItem}
          dateBookingStart_UTC={this.state.DateBookingStart_UTC}
          dateBookingEnd_UTC={this.state.DateBookingEnd_UTC}
          dateBookingStart={this.state.DateBookingStart}
          dateBookingEnd={this.state.DateBookingEnd}
          onRegisterSuccess={this.updateReservation}
          closeModal={this.closeModalBooking}
          isOpen={this.state.modalBooking}
          UserReducer={this.props.UserReducer}
        />

        <ModalDetailMyAsset 
          allowBooking    = {true}
          ModalState      = {this.state.modalDetail}
          CloseModal      = {this.closeModalDetail}
          SelectedItems   = {this.state.SelectedItem}
          UserReducer     = {this.props.UserReducer}
          toggleModalBooking={this.toggleModalBooking}
          // only in this page
          isUpdateReservation={this.state.isUpdateReservation}
          dateBookingStart_UTC={this.state.DateBookingStart_UTC}
          dateBookingEnd_UTC={this.state.DateBookingEnd_UTC}
          setIsUpdateReservation={(state) => this.setState({
            isUpdateReservation : state
          })}
        />

        {/* <ModalDetailAsset
          activeTabNotes={this.state.ActiveTabNotes}
          isUpdateReservation={this.state.isUpdateReservation}
          dateBookingStart_UTC={this.state.DateBookingStart_UTC}
          dateBookingEnd_UTC={this.state.DateBookingEnd_UTC}
          selectedItem={this.state.SelectedItem}
          isOpen={this.state.modalDetail}
          closeModal={this.closeModalDetail}
          toggleModalBooking={this.toggleModalBooking}
          disabledBook={this.state.disabledBook}
          isFromQR={false}
          setIsUpdateReservation={(state) => this.setState({
            isUpdateReservation : state
          })}
          UserReducer={this.props.UserReducer}
        /> */}

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/asset/simple_asset/helper/component/AllAsset/AllAssetList.js